// ezlo.js has a circular import chain (blockActionTemplate → containers → services → store),
// so the heavy imports are mocked to test the reducer in isolation.
jest.mock('../../components/blockActionTemplate', () => ({ __esModule: true, default: {} }));
jest.mock('../../containers/Ezlo/EzloMeshbot/utils', () => ({ isChangedHotzones: jest.fn() }));

import reducer from '../ezlo';
import * as types from '../../constants/ActionTypes';

const SERIAL = '92001952';
const RULE_ID = '666c1630940d8121d45808e3';
const OTHER_RULE_ID = '6673d15b940d8121d45808ec';

/**
 * Builds UPDATE_RULE action with the same shape as EzloActions.updateRule
 * @param {string} serial - controller serial number
 * @param {string} _id - rule id
 * @param {Object} data - partial rule data to merge
 * @returns {Object} UPDATE_RULE action
 */
const updateRule = (serial, _id, data) => ({ type: types.UPDATE_RULE, serial, _id, data });

const getStateWithRules = () => ({
    data: {
        [SERIAL]: {
            rules: [
                { _id: RULE_ID, name: 'First MeshBot', enabled: true },
                { _id: OTHER_RULE_ID, name: 'Second MeshBot', enabled: true },
            ],
        },
    },
});

describe('ezlo reducer — UPDATE_RULE', () => {
    it('should merge data into the rule found by _id', () => {
        const state = reducer(getStateWithRules(), updateRule(SERIAL, RULE_ID, { enabled: false }));

        expect(state.data[SERIAL].rules[0]).toEqual({ _id: RULE_ID, name: 'First MeshBot', enabled: false });
    });

    it('should not affect other rules', () => {
        const state = reducer(getStateWithRules(), updateRule(SERIAL, RULE_ID, { enabled: false }));

        expect(state.data[SERIAL].rules[1]).toEqual({ _id: OTHER_RULE_ID, name: 'Second MeshBot', enabled: true });
    });

    it('should return new rules array and rule object references (immutability)', () => {
        const initialState = getStateWithRules();
        const state = reducer(initialState, updateRule(SERIAL, RULE_ID, { enabled: false }));

        expect(state.data[SERIAL].rules).not.toBe(initialState.data[SERIAL].rules);
        expect(state.data[SERIAL].rules[0]).not.toBe(initialState.data[SERIAL].rules[0]);
        expect(initialState.data[SERIAL].rules[0].enabled).toBe(true);
    });

    it('should return the same state when the rule is not found', () => {
        const initialState = getStateWithRules();
        const state = reducer(initialState, updateRule(SERIAL, 'unknown-id', { enabled: false }));

        expect(state).toBe(initialState);
    });

    it('should return the same state when the controller has no rules', () => {
        const initialState = { data: { [SERIAL]: {} } };
        const state = reducer(initialState, updateRule(SERIAL, RULE_ID, { enabled: false }));

        expect(state).toBe(initialState);
    });

    it('should return the same state when the controller is unknown', () => {
        const initialState = getStateWithRules();
        const state = reducer(initialState, updateRule('00000000', RULE_ID, { enabled: false }));

        expect(state).toBe(initialState);
    });

    it('should merge partial data without losing other rule fields', () => {
        const state = reducer(getStateWithRules(), updateRule(SERIAL, RULE_ID, { imageId: 'img-1' }));

        expect(state.data[SERIAL].rules[0]).toEqual({
            _id: RULE_ID,
            name: 'First MeshBot',
            enabled: true,
            imageId: 'img-1',
        });
    });
});
